import BlogView from './BlogView'
export default BlogView



// WEBPACK FOOTER //
// ./src/components/BlogView/index.js